import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openPanel } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelActions';
import { displayRecipientManager } from 'SelfServePostBuilderSidePanel/SelfServePostBuilderSidePanelActions';
import { SelfServeBuilderSidePanelTypes } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelConstants';
import { PrimaryButton, SecondaryButton } from 'DesignSystem/Buttons';

class SelfServeBuilderPostSharePanel extends React.Component {
  static viewResponses() {
    window._track('View or Cancel Responses', 'Template Builder');
    window.location.assign(`/self-serve-responses?documentType=${window.CurrentDocument.type}`);
  }

  constructor(props) {
    super(props);
    this.openRecipientPanel = this.openRecipientPanel.bind(this);
  }

  openRecipientPanel() {
    this.props.openPanel(SelfServeBuilderSidePanelTypes.POST_BUILDER);
    this.props.displayRecipientManager();
  }

  render() {
    const { isOpenPostBuilderSidePanel } = this.props;

    return (
      <React.Fragment>
        <div className="self-serve-builder-post-share-overlay" />
        <div className="self-serve-builder-post-share-panel">
          <img
            alt="Post Share Overlay Icon"
            className="self-serve-builder-post-share-icon"
            src="/images/self-serve-builder/post-share-overlay/success-icon.png"
          />
          <p className="self-serve-builder-post-share-text">Your Document Has Been Shared.</p>
          <div className="share-with-more-recipients-container">
            <SecondaryButton
              className="share-with-more-recipients-button"
              disabled={isOpenPostBuilderSidePanel}
              onClick={this.openRecipientPanel}
            >
              Share with More Recipients
            </SecondaryButton>
          </div>
          <div className="view-responses-container">
            <PrimaryButton
              className="self-serve-builder-post-share-view-responses-button"
              onClick={SelfServeBuilderPostSharePanel.viewResponses}
            >
              View Responses
            </PrimaryButton>
            <p className="cancel-request-text">(or cancel requests)</p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SelfServeBuilderPostSharePanel.defaultProps = {
  displayRecipientManager: () => {},
  isOpenPostBuilderSidePanel: false,
};

SelfServeBuilderPostSharePanel.propTypes = {
  displayRecipientManager: PropTypes.func,
  isOpenPostBuilderSidePanel: PropTypes.bool,
  openPanel: PropTypes.func.isRequired,
};

const mapStateToProps = ({ SelfServeBuilderSidePanelHandler }) => ({
  isOpenPostBuilderSidePanel: SelfServeBuilderSidePanelHandler[
    SelfServeBuilderSidePanelTypes.POST_BUILDER
  ].isOpen,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    displayRecipientManager,
    openPanel,
  }, dispatch)
);

export const SelfServeBuilderPostSharePanelWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelfServeBuilderPostSharePanel);

export default SelfServeBuilderPostSharePanelWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderPostSharePanel/index.jsx